import React, {useEffect, useState} from 'react';import {
  GetStaticProps, GetStaticPropsResult,
  NextPage,
} from 'next';
import {CommonServerSideParams} from '@/app/types/CommonServerSideParams';
import {OnlyBrowserPageProps} from '@/layouts/web/types/OnlyBrowserPageProps';
import {SSGPageProps} from '@/layouts/web/types/SSGPageProps';
import {StaticPropsInput} from '@/app/types/StaticPropsInput';
import {
  getWebLayoutStaticProps,
} from '@/layouts/web/webLayoutSSG';
import WebLayout from '@/layouts/web/components/WebLayout';
import {getReactDivApiConfig} from '@/modules/core/reactDivAPI/utils/getApiConfig';
import deepmerge from 'deepmerge';
import PageHeader from "@/components/centralbrisbanedental/page/Header/Header";
import Annoucement from "@/components/centralbrisbanedental/Announcement";
import Topbar from "@/components/centralbrisbanedental/Topbar";
import NavBar from "@/components/centralbrisbanedental/NavBar/NavBar";
import CTABannerImageDescriptive
  from "@/components/centralbrisbanedental/CTABannerImageDescriptive/CTABannerImageDescriptive";
import CTABannerSplitTiles from "@/components/centralbrisbanedental/CTABannerSplitTiles/CTABannerSplitTiles";
import TwoColumnContent from "@/components/centralbrisbanedental/TwoColumnContent/TwoColumnContent";
import Footer from "@/components/centralbrisbanedental/Footer/Footer";
import {createLogger} from '@/modules/core/logging/logger';


const fileLabel = 'pages/index';
const logger = createLogger({ // eslint-disable-line no-unused-vars,@typescript-eslint/no-unused-vars
  fileLabel,
});

let philosophyContentA: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Central Brisbane Dental provides all general ' +
              'dental services, coupling a friendly approach with the latest technology.  ' +
              'A projector is set up in each surgery so the patient can relax and watch their favourite DVD while' +
              ' treatment is provided.  ' +
              'Penthrox gas sedation is available for those who are very nervous.  ' +
              'An autoclave is used to sterilise instruments used in all procedures.  ' +
              'A digital x-ray system is used to reduce radiation to a minimum.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Many procedures can be done using pain-free ' +
              'preventive techniques without the need for an injection.  ' +
              'Of course, an injection will be offered where it is required. ' +
              'We believe in continuing education to give our patients the latest information in the ' +
              'dental health field.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'supertoothy character',
              src: '/static/images/tiles/super-toothy-philosophy.webp',
              height: 320,
              width: 463,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]
let philosophyContentB: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      alignment: 'items-center'
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Central Brisbane Dental can give you the ' +
              'smile you always wanted, with our extensive knowledge on smile design and wide range of cosmetic' +
              ' dental treatments.  Teeth whitening with the famous Zoom! in-office system or Pola take-home' +
              ' system can give a whiter, brighter smile straight away.  ' +
              'ClearPath orthodontic aligners can straighten teeth with no need for wires, brackets or attachments.  ' +
              'Quick Straight Teeth cosmetic braces can straighten front teeth in 6 months.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Cosmetic fillings, veneers and crowns can ' +
              'give the tooth the perfect shape, size and colour.  ' +
              'Dental implants can replace a missing tooth or tooth that needs an extraction.  ' +
              'We offer patients free 30 minute consultations to talk about cosmetic options available to that ' +
              "patient and whether dental implants are suitable. <a href=\'/static/pdf/promotion-terms-and-conditions.pdf\'>View Terms and Conditions</a>",
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'relaxed dental patient receiving treatment',
              src: '/static/images/tiles/relaxed-dental-patient.webp',
              height: 320,
              width: 463,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]
let philosophyContentC: any = [
  {
    element: 'flexRow',
    classes: {
      display: "flex flex-col sm:flex-row",
      margin: "mt-8"
    },
    children: [
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'Central Brisbane Dental can process most ' +
              'heath fund claims for you through our HICAPS terminal, with the patient only paying the gap amount.  ' +
              'Patients with CBHS and HCF usually have no gap to pay on check-up and clean and certain preventive ' +
              'services as we are a part of the CBHS Choice Network and the HCF More for Teeth Program.  ' +
              'We are preferred providers for nib, as well as Australian Unity, AIA Health Insurance and Peoplecare ' +
              'through our association with Smile.com.au. Health.com.au, Frank, GMHBA, My Own Health Insurance, ' +
              'and Healthcare Insurance are also partner health funds.',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
          {
            element: 'paragraph',
            type: 'richParagraph',
            value: 'We also accept Medicare Child Dental ' +
              'Benefits Schedule, DVA and SACM patients as well as patients with overseas insurances such as ' +
              'First Assistance or Cigna.  ' +
              'We pride ourselves in using Australian dental laboratories for all work including veneers, crowns, ' +
              'bridges, dental implants, dentures, sports mouthguards, occlusal splints (MCI) and snoring and ' +
              'sleep apnoea splints (MDSA).',
            classes: {
              margin: "mb-4",
              colour: "text-gray-900",
              fontSize: "text-md",
              letterSpacing: "tracking-tight",
              lineHeight: "leading-8",
            }
          },
        ]
      },
      {
        element: 'flexCol',
        classes: {
          display: "flex-row sm:flex-col basis-full sm:basis-1/2",
          margin: "sm:px-8 sm:py-4"
        },
        children: [
          {
            element: 'image',
            imageProperties: {
              layout: 'fixed',
              alt: 'supertoothy and battoothy fighting decay and germs.',
              src: '/static/images/tiles/super-toothy-battle-philosophy.webp',
              height: 320,
              width: 463,
            },
            imageClasses: {
              textAlign: "center"
            }
          }
        ]
      },
    ]
  },
]

/**
 * Only executed on the server side at build time.
 * Necessary when a page has dynamic routes and uses "getStaticProps".
 */
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths({fallback:true});
// export const getStaticPaths: GetStaticPaths<CommonServerSideParams> = getPublicLayoutStaticPaths();

/**
 * Only executed on the server side at build time.
 *
 * @return Props (as "SSGPageProps") that will be passed to the Page component, as props.
 *
 * @see https://github.com/vercel/next.js/discussions/10949#discussioncomment-6884
 * @see https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 */
export const getStaticProps: GetStaticProps<SSGPageProps, CommonServerSideParams> = async (props: StaticPropsInput): Promise<GetStaticPropsResult<SSGPageProps>> => {
  const commonStaticProps: GetStaticPropsResult<SSGPageProps> = await getWebLayoutStaticProps()(props);
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('getStaticProps commonStaticProps', commonStaticProps); // eslint-disable-line no-console
  }

  if ('props' in commonStaticProps) {
    const config = getReactDivApiConfig();

    const [
      // Below is Web Module
      // currentShelledPage,
      // currentClientProjectSEOSettings,
      // currentShelledPageSeoSettings, // NOTE This is a dependency, should loop through these
      // currentClientProjectSEOSettings,
      // Above is Web Module
    ] = await Promise.all([
      // Below is Web Module
      // getShelledPageBySingularAPIID({config, slug: 'home'}),
      // getSystemShelledFieldsBySystemShellID({config, systemShellID: '630f756db23725aedbc16e7d'}),
      // getClientProjectContentBySystemShellID({
      //   config,
      //   clientID: commonStaticProps.props.reactDivClientID,
      //   projectID: commonStaticProps.props.reactDivClientProjectID,
      //   systemShellID: '630f756db23725aedbc16e7d',
      // }),
      // getBySingularAPIID({config, slug: "home"}),
      // Above is Web Module
    ]);

    return deepmerge(commonStaticProps, {
      props: {
        // Below is Web Module
        // currentShelledPage,
        // currentShelledPageSeoSettings,
        // currentClientProjectSEOSettings,
        // Above is Web Module
        builtAt: new Date().toISOString(),
      },
      // revalidate: regenerationDelay,
    });
    // return commonStaticProps;
  } else {
    return commonStaticProps;
  }

};
/**
 * SSG pages are first rendered by the server (during static bundling).
 * Then, they're rendered by the client, and gain additional props (defined in OnlyBrowserPageProps).
 * Because this last case is the most common (server bundle only happens during development stage), we consider it a default.
 * To represent this behaviour, we use the native Partial TS keyword to make all OnlyBrowserPageProps optional.
 *
 * Beware props in OnlyBrowserPageProps are not available on the server.
 */
type Props = {} & SSGPageProps<Partial<OnlyBrowserPageProps>>;

/**
 * Example of a public page.
 */
const OurPhilosophy: NextPage<Props> = (props): JSX.Element => {
  if (process.env.NEXT_PUBLIC_APP_STAGE !== 'production') {
    logger.info('OurPhilosophy: props', props); // eslint-disable-line no-console
  }
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY)
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {;
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <>
      <WebLayout
        // reactDivClientID={}
        // reactDivClientProjectID={}
        hideFooter={false}
        pageSeoSettings={{
          seoTitle: 'Our Dental Philosophy | Local Brisbane Dentists',
          seoDescription: 'Central Brisbane Dental provide affordable dental treatment with regular promotions for new patients, as well as regular patient specials. Brisbane dentist Dr Vincent Wan has over 20 yrs experience. ',
          seoImage: '/static/images/tiles/sunbaking-toothy-teeth-whitening.png.webp',
          favicon: '/static/images/favicon/favicon-96.png',
        }}
      >
        <PageHeader
          title="Our Philosophy"
          background="bg-[#400068]"
          backgroundImage="/static/images/headers/life-cycle-header-overlay.png"
        />
        <main>
          <TwoColumnContent
            title="Looking After You!"
            heading="At Central Brisbane Dental, getting the best outcome for your oral health is our number one priority."
            content={philosophyContentA}
          />
          <CTABannerImageDescriptive
            imageProperties={{
              layout: 'intrinsic',
              alt: 'happy toothy character',
              type: 'dimensions',
              src: '/static/images/tiles/sunbaking-toothy-teeth-whitening.png.webp',
              height: 285,
              width: 412.5,
            }}
            title="Philips Zoom"
            heading="Teeth Whitening for just $660!"
            description="Come in for a free consultation."
            buttonText="View terms and conditions"
            buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
            imageClasses={{
              textAlign: "center",
              padding: "p-5"
            }}
            titleClasses={{
              dynamicColour: '#ff6600',
              fontSize: 'text-base',
              fontWeight: 'semibold',
              letterSpacing: 'tracking-wider',
              uppercase: true,
            }}
            headingClasses={{
              margin: 'mt-2',
              fontSize: 'text-2xl sm:text-3xl',
              fontWeight: 'extrabold',
              letterSpacing: 'tracking-tight',
              colour: 'text-white',
            }}
            descriptionClasses={{
              margin: 'mt-3',
              fontSize: 'text-lg',
              colour: 'text-white'
            }}
            buttonClasses={{
              border: 'border border-transparent rounded-md',
              display: 'inline-flex',
              padding: 'px-5 py-3',
              dynamicBackground: '#17aaab',
              fontSize: 'text-base',
              fontWeight: 'medium',
              colour: 'text-black',
            }}
            classes={{
              position: 'relative',
              dynamicBackground: '#070707',
            }}
          />
          <TwoColumnContent
            title="Looking After Your Teeth!"
            // heading="How to get to our dental clinic in Brisbane city & things to know before coming in."
            content={philosophyContentB}
          />
          <CTABannerSplitTiles
            dentist="vincent"
            heading="Did you know?"
            value="You can get 2 checkup and cleans a year for $0 or a very small out-of-pocket when you come and see us and use your health fund."
            buttonText="View terms and conditions"
            buttonDestination="/static/pdf/promotion-terms-and-conditions.pdf"
            hasInset={true}
            insetClasses={{
              display: 'hidden lg:block',
              position: 'absolute top-0 inset-x-0',
              height: 'h-1/2',
              dynamicBackground: '#400068'
            }}
            buttonClasses={{
              border: 'border border-transparent rounded-md',
              display: 'inline-flex',
              padding: 'px-5 py-3',
              dynamicBackground: '#17aaab',
              fontSize: 'text-base',
              fontWeight: 'medium',
              colour: 'text-black',
            }}
            classes={{
              position: 'relative',
              dynamicBackground: '#fff',
              padding: 'py-16'
            }}
          />
          <TwoColumnContent
            title="Looking After Your Back Pocket!"
            heading="How to get to our dental clinic in Brisbane city & things to know before coming in."
            content={philosophyContentC}
          />
        </main>
      </WebLayout>
    </>
  );
};

export default OurPhilosophy;
